import React from 'react';

const universities = {
  A: ["Aachen University of Technology (RWTH Aachen)", "Anhalt University of Applied Sciences"],
  B: ["Berlin Institute of Technology", "Bielefeld University", "Bonn University", "Braunschweig University of Technology"],
  C: ["Chemnitz University of Technology", "Christian-Albrechts-University of Kiel"],
  D: ["Dresden University of Technology", "Dortmund University", "Darmstadt University of Applied Sciences"],
  E: ["University of Erlangen–Nuremberg", "European University Viadrina Frankfurt (Oder)"],
  F: ["Frankfurt University of Applied Sciences", "Freie Universität Berlin", "Freiburg University"],
  G: ["Goethe University Frankfurt", "Greifswald University"],
  H: ["Heidelberg University", "Hamburg University of Technology", "Hannover University"],
  J: ["Jacobs University Bremen", "Jena University (Friedrich Schiller University)"],
  L: ["Leipzig University", "Ludwig Maximilian University of Munich"],
  M: ["Munich University of Technology (TUM)", "Martin Luther University of Halle-Wittenberg", "Magdeburg University"],
  P: ["Paderborn University", "Passau University", "Potsdam University"],
  R: ["Rostock University", "Ruhr University Bochum"],
  S: ["Stuttgart University", "Saarland University"],
  T: ["Technical University of Berlin", "Technical University of Munich", "Technical University of Kaiserslautern"],
  U: ["University of Ulm"],
  W: ["Wuppertal University", "Würzburg University"],
};

const GermanyUniversities = () => {
  return (
    <div className="uk-container">
      <h2 className="uk-title">Germany Universities</h2>
      <table className="uk-table">
        <thead>
          <tr>
            <th>Letter</th>
            <th>University Name</th>
          </tr>
        </thead>
        <tbody>
          {Object.entries(universities).map(([letter, uniList]) =>
            uniList.map((uni, idx) => (
              <tr key={`${letter}-${idx}`}>
                <td>{idx === 0 ? letter : ''}</td>
                <td>{uni}</td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};

export default GermanyUniversities;
